import {
  takeLatest, put, select, all, call,
} from 'redux-saga/effects';
import { get } from '@api/sharing';
import { autoRequest } from '@api/createRequestStore';
import { DASHBOARD_TYPE } from '@utils/constants';
import { message } from 'antd';
import { TRIGGER_ADD_TAB } from '@store/dashboards/tabs/types';
import * as autoRequestTypes from '@api/createRequestStore/types';
import { addNewSharedTab } from '../../sharedTabs/action';
import * as actions from './actions';
import * as types from './types';
import selector, { sharingResponseSelector } from './selectors';

function* afterRequest() {
  const { state } = yield select(sharingResponseSelector);

  if (!state) {
    return;
  }

  const { payload } = yield select(selector);

  try {
    const {
      common,
    } = state;

    const { selectedCustomerId } = common;

    yield all([
      put(
        addNewSharedTab(
          {
            id: payload,
            state,
            type: DASHBOARD_TYPE.VIEWER_MODULE,
          },
          selectedCustomerId,
        ),
      ),
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config: { base: state },
          dashboardTypeId: DASHBOARD_TYPE.VIEWER_MODULE,
          unsaved: true,
          id: payload,
          name: `Viewer Module ${payload}`,
          isSharing: true,
        },
      }),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching(action) {
  try {
    yield put({ type: `${types.SCOPE}${autoRequestTypes.FETCHING}` });
    yield autoRequest(get, types.SCOPE, action.id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

export default [watchInitRequest, watchFetching];
